import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 16 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 18\" id=\"icon-plus\"><path d=\"M8.67.965H7.33c-.119 0-.178.06-.178.179v7.009H.5c-.119 0-.178.06-.178.178v1.34c0 .119.06.178.178.178h6.652v7.01c0 .118.06.178.178.178h1.34c.119 0 .178-.06.178-.179V9.85H15.5c.12 0 .179-.06.179-.178V8.33c0-.119-.06-.178-.179-.178H8.848v-7.01c0-.118-.06-.178-.179-.178z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol